import styled, { CSSProperties } from "styled-components";

export const Container = styled.div<{ $imageUrl?: string }>`
	width: 100%;
	height: 69em;
	padding: 0;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	background-image: url(${(props) => props.$imageUrl});
	background-repeat: no-repeat;
	background-size: calc(100% - 2px) calc(100% - 2px);
	background-position: center;
	font-size: clamp(8px, 2.5dvw, 19px);

	@media (min-width: 734px) {
		height: 46.45em;
		font-size: clamp(2px, 0.92dvw, 12px);
	}
`;

export const NodesContainer = styled.div`
	width: 100%;
	height: 23.74em;
	position: absolute;
	top: 17.65em;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin-left: 18%;

	&.several-nodes {
		height: 19.32em;
		margin-left: 14%;
	}
`;

export const NodesContainerThreePortrait = styled.div`
	width: 33.75em;
	height: 58.65em;
	position: absolute;
	top: 14.75em;
`;

export const NodesContainerSixPortrait = styled.div`
	width: 34.5em;
	height: 49.09em;
	position: absolute;
	top: 14.75em;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	grid-template-rows: repeat(3, minmax(0, 1fr));
	gap: 0.5em;
`;

export const RopesSixPortraitLayer = styled.div`
	position: absolute;
	inset: 0;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	grid-template-rows: repeat(3, minmax(0, 1fr));
	gap: 0.5em;
	z-index: 0;
	pointer-events: none;
`;

export const RopeSixPortraitSlot = styled.div`
	position: relative;
	min-width: 0;
	min-height: 0;

	&::before {
		content: "";
		display: block;
		width: 100%;
		height: 100%;
	}
`;

export const PalmTrees = styled.img`
	position: absolute;
	inset: 0;
	top: 1px;
	left: 1px;
	width: calc(100% - 2px);
	height: calc(100% - 2px);
	object-fit: fill;
	z-index: 3;
	pointer-events: none;
`;

export const BgBrush = styled.img`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 4;
	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	-webkit-touch-callout: none;
	-webkit-tap-highlight-color: transparent;
	pointer-events: none;
`;

export const UnderConstruction = styled.img`
	position: absolute;
	width: 80%;
	top: 30%;
`;

export const Rope = styled.img`
	position: absolute;
	top: 5.6%;
	width: 100%;
	margin-right: 18%;
	height: 6%;

	&.several-nodes {
		top: 5%;
		height: 6.5%;
	}
`;

export const RopeThreePortrait = styled.img`
	position: absolute;
	left: 50%;
	top: 101%;
	transform: translate(-50%, -50%) rotate(90deg);
	height: 3%;
	z-index: 0;
`;

export const RopeSixPortrait = styled.img`
	position: relative;
	bottom: 52%;
	right: 38%;
	height: 10%;
	z-index: 1;

	&.first {
		rotate: 180deg;
		left: 62%;
	}

	&.vertical {
		rotate: 90deg;
		bottom: 10%;
		left: 15%;
	}
`;

export const Title = styled.img`
	height: 10%;
	position: absolute;
	left: 50%;
	top: 14%;
	transform: translate(-50%, -50%);
	z-index: 3;
	pointer-events: none;

	@media (min-width: 734px) {
		height: 20%;
		top: 27%;
	}
`;

export const timerStyle: CSSProperties = {
	fontSize: "2em",
	whiteSpace: "nowrap",
	padding: "0.3em 0.6em",
	backgroundColor: "#fff",
	top: "10%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	zIndex: 5
};

export const timerStyleMobile: CSSProperties = {
	...timerStyle,
	fontSize: "1.2em",
	top: "5%"
};
